// import React from 'react'
import styled from 'styled-components'

export const VersionsContainer = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;

  & ul {
    padding: 0 0 0 20px;

    li {
      display: flex;
      justify-items: flex-start;
    }
  }
`
export const Description = styled.div`
  color: var(--text-subheading);
  width: 80%;

  span {
    height: 3px;
    width: 3px;
    background-color: var(--text-heading);
    border-radius: 50%;
    display: inline-block;
    position: relative;
    bottom: 3px;
  }
`
export const Period = styled.div`
  color: var(--text-disabled);
  width: 20%;
  text-align: right;
  font-size: 10px;
`
export default function AppNews({ versions }) {
  return (
    <>
      {versions.length !== 0 ? (
        <VersionsContainer>
          <ul>
            {versions.map((item) => (
              <li key={item.id}>
                <Description>
                  <span></span> {item.versionNumber} - {item.description}
                </Description>
                <Period>{item.releaseTicketNumber}</Period>
              </li>
            ))}
          </ul>
        </VersionsContainer>
      ) : (
        <div>None provided</div>
      )}
    </>
  )
}
